<template lang="pug">
svg(
    :width="size"
    :height="size"
    viewBox="0 0 11 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
)
    g(
        :class="{ error, success }"
        clip-path="url(#clip0)"
        class="svg"
    )
        path(
            d="M9.70581 1.25191L3.35209 7.60564L0.849009 5.10256L-0.000366211 5.95194L3.35209 9.30439L10.5552 2.10128L9.70581 1.25191Z"
            fill="currentColor"
        )
    defs
        clipPath#clip0
            rect(
                width="10.5556"
                height="10.5556"
                transform="translate(-0.00012207 0.000213623)"
            )
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
    size: {
        type: [String, Number],
        default: 14,
    },
    error: Boolean,
    success: Boolean,
})

const size = computed(() => parseInt(`${props.size}`, 10))
</script>
